import actionTypes from '../actions/actionTypes'

const defaultState = {
	data: {},
	personalInfoErrors: {},
	changePasswordErrors: {},
	showSchoolButtons: false,
	showTeacherButtons: false,
	showProfileImageUploading: false,
	schools: [],
	advancedSettings: [],
	notifications: {},
	loaded: false,
}

function setMyAccountData(state, action) {
	const newState = {...state}
	const newData = {...state.data}
	newData.percentStorage = action.payload.percentStorage
	newData.usedStorage = action.payload.usedStorage
	newData.maxStorage = action.payload.maxStorage
	newData.zipCode = action.payload.zipCode
	newData.grades = action.payload.grades
	newData.gradeIds = action.payload.gradeIds
	newData.subjects = action.payload.subjects
	newData.subjectIds = action.payload.subjectIds
	newData.countries = action.payload.countries
	newData.countryIdUS = action.payload.countryIdUS
	newData.countryId = action.payload.countryId
	newData.showState = action.payload.showState
	newData.states = action.payload.states
	newData.stateId = action.payload.stateId
	newData.institutionName = action.payload.institution
	newData.institutionId = action.payload.institutionId
	newData.city = action.payload.city
	newData.roles = action.payload.roles
	newData.roleId = action.payload.roleId
	newData.notes = action.payload.notes
	newData.canEditInstitution = action.payload.canEditInstitution
	newData.isNearpodLogin = !!action.payload.isNearpodLogin
	newData.hasPassword = action.payload.hasPassword
	newState.data = newData
	newState.loaded = true
	return newState
}

function personalInfoErrors(state, action) {
	const newState = {...state}
	newState.personalInfoErrors = action.errors
	return newState
}

function changePasswordErrors(state, action) {
	return {
		...state,
		changePasswordErrors: action.errors,
	}
}

function schoolsFetched(state, action) {
	return {
		...state,
		schools: action.payload.results,
	}
}

function resetPersonalErrors(state) {
	const newState = {...state}
	newState.personalInfoErrors = {}
	return newState
}

function resetPasswordErrors(state) {
	return {
		...state,
		changePasswordErrors: {},
	}
}

function showSchoolButtons(state, show) {
	const newState = {...state}
	newState.showSchoolButtons = show
	return newState
}

function showTeacherButtons(state, show) {
	const newState = {...state}
	newState.showTeacherButtons = show
	return newState
}

function setTeacherInfo(state, action) {
	const newState = {...state}
	const newData = {...state.data}
	newData.gradeIds = action.gradeIds
	newData.subjectIds = action.subjectIds
	newState.data = newData
	return newState
}

function saveSchoolInfo(state, action) {
	const newState = {...state}
	const newData = {...state.data}
	newData.countryId = action.countryId
	newData.stateId = action.stateId
	newData.city = action.city
	newData.institutionId = action.institutionId
	newData.institutionName = action.institutionName
	newState.data = newData
	return newState
}

function saveAdvancedSettings(state, action) {
	const newState = {...state}
	const newAdvancedSettings = [...state.advancedSettings]
	const newSetting = {...state.advancedSettings[action.index]}
	newSetting.value = (state.advancedSettings[action.index].value === '1') ? '0' : '1'
	newAdvancedSettings[action.index] = newSetting
	newState.advancedSettings = newAdvancedSettings
	return newState
}

function saveAdvancedSettingsSuccess(state) {
	const newState = {...state}
	return newState
}

function saveAdvancedSettingsFailed(state) {
	const newState = {...state}
	return newState
}

function getAdvancedSettingsSuccess(state, action) {
	const newState = {...state}
	newState.advancedSettings = action.payload.advancedSettings
	return newState
}

function getAdvancedSettingsFailed(state) {
	const newState = {...state}
	return newState
}

function setProfileImageUploading(state, value) {
	const newState = {...state}
	newState.showProfileImageUploading = value
	return newState
}

function clearSchoolSearch(state) {
	const newState = {...state}
	newState.schools = []
	return newState
}

const myAccountReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.MY_ACCOUNT_DATA_FETCHED: {
			return setMyAccountData(state, action)
		}
		case actionTypes.MY_ACCOUNT_SAVE_PERSONAL_INFO_FAILED: {
			return personalInfoErrors(state, action)
		}
		case actionTypes.MY_ACCOUNT_SAVE_PERSONAL_INFO_SUCCESS: {
			return resetPersonalErrors(state)
		}
		case actionTypes.MY_ACCOUNT_CHANGE_PASSWORD_SUCCESS: {
			return resetPasswordErrors(state)
		}
		case actionTypes.MY_ACCOUNT_SAVE_SCHOOL_INFO_SUCCESS: {
			const newState = saveSchoolInfo(state, action)
			return showSchoolButtons(newState, false)
		}
		case actionTypes.MY_ACCOUNT_SAVE_TEACHER_INFO_SUCCESS: {
			let newState = setTeacherInfo(state, action)
			newState = showTeacherButtons(newState, false)
			return newState
		}
		case actionTypes.MY_ACCOUNT_SCHOOLS_FETCHED: {
			return schoolsFetched(state, action)
		}
		case actionTypes.MY_ACCOUNT_SHOW_SCHOOL_BUTTONS: {
			return showSchoolButtons(state, action.show)
		}
		case actionTypes.MY_ACCOUNT_SHOW_TEACHER_BUTTONS: {
			return showTeacherButtons(state, action.show)
		}
		case actionTypes.MY_ACCOUNT_SAVE_ADVANCED_SETTINGS: {
			return saveAdvancedSettings(state, action)
		}
		case actionTypes.MY_ACCOUNT_SAVE_ADVANCED_SETTINGS_SUCCESS: {
			return saveAdvancedSettingsSuccess(state, action)
		}
		case actionTypes.MY_ACCOUNT_SAVE_ADVANCED_SETTINGS_FAILED: {
			return saveAdvancedSettingsFailed(state, action)
		}
		case actionTypes.MY_ACCOUNT_GET_ADVANCED_SETTINGS_SUCCESS: {
			return getAdvancedSettingsSuccess(state, action)
		}
		case actionTypes.MY_ACCOUNT_GET_ADVANCED_SETTINGS_FAILED: {
			return getAdvancedSettingsFailed(state, action)
		}
		case actionTypes.MY_ACCOUNT_UPLOAD_PROFILE_IMAGE: {
			return setProfileImageUploading(state, true)
		}
		case actionTypes.MY_ACCOUNT_SAVE_ICON_SUCCESS:
		case actionTypes.MY_ACCOUNT_UPLOADER_VALIDATE_ERROR:
		case actionTypes.MY_ACCOUNT_UPLOADER_UPLOAD_ERROR: {
			return setProfileImageUploading(state, false)
		}
		case actionTypes.MY_ACCOUNT_CHANGE_COUNTRY:
		case actionTypes.MY_ACCOUNT_CHANGE_STATE: {
			return clearSchoolSearch(state, action)
		}
		case actionTypes.MY_ACCOUNT_CHANGE_PASSWORD_FAILED: {
			return changePasswordErrors(state, action)
		}

		default: return state
	}
}

export default myAccountReducer
